export default function LoadingIndicator({className})
{
  return <div className={`lds-ripple ${className}`}><div /><div /></div>;
}

export function CenteredLoadingIndicator()
{
  return <div className="text-center text-2xl"><LoadingIndicator /></div>
}
